const menuMaxWidth = '304px'

export default () =>
  ({
    menuWidthHelper: {
      maxWidth: menuMaxWidth,
    },
  }) as const
